import React from 'react';

interface ITargetProps {
  color?: string;
}

const Target = ({ color = 'var(--dui-primary)' }: ITargetProps) => {
  return (
    <svg
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      style={{ fill: color }}
    >
      <path
        d="m558.532 277.63h-2.014c-.007 0-.014 0-.021 0a7.62 7.62 0 0 0 -7.285-7.24.288.288 0 0 0 .012-.057v-2.015a.346.346 0 0 0 -.692 0v2.015a.292.292 0 0 0 .012.059 7.635 7.635 0 0 0 -7.269 7.241c-.013 0-.024-.007-.037-.007h-2.014a.346.346 0 1 0 0 .692h2.014c.013 0 .024-.006.036-.007a7.635 7.635 0 0 0 7.261 7.284v.017 2.014a.346.346 0 0 0 .692 0v-2.014-.015a7.51 7.51 0 0 0 4.342-1.609l1.331-1.3a7.531 7.531 0 0 0 1.609-4.377h.015 2.014a.346.346 0 1 0 0-.692zm-9.654 6.143a5.776 5.776 0 1 1 5.779-5.785 5.768 5.768 0 0 1 -5.779 5.785zm0-10.194a3.436 3.436 0 0 0 -3.436 3.439c0 1.486 2.121 4.267 3.033 5.37a.52.52 0 0 0 .806 0c.912-1.125 3.032-3.884 3.032-5.37a3.423 3.423 0 0 0 -3.435-3.439zm0 4.925a1.486 1.486 0 1 1 1.484-1.486 1.477 1.477 0 0 1 -1.484 1.482z"
        transform="translate(-538.878 -267.976)"
      />
    </svg>
  );
};

export default Target;
